import CKEditor from "ckeditor4-vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css"; // 和引入.APP的顺序会影响打包后的样式

import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./axios";
import utils from "./assets/js/utils";
import customConst from "./assets/json/const";
import "./assets/css/util.less";
import "./assets/css/zoe.less";
import CustomComponents from "./components";
import "./filter";
import "./mixin";
import "./router/beforeEach"; // 导航守卫
import mqtt from "./assets/js/mqtt";
import "@/assets/js/directives";
import Viewer from "v-viewer"; //引入命令
// import "viewerjs/dist/viewer.css"; //引入css样式
import IndexDB from '@/assets/js/myIndexDB'
import AMap from "./assets/js/aMap"
import WatermarkPlugin from "@/components/watermark/plugin";
import './assets/css/style.css'

Vue.use(Viewer); //全局使用
Viewer.setDefaults({
  Options: {
    'zIndex': 9999
  },
  toolbar: {
    zoomIn: true, //	放大图片的按钮
    zoomOut: true, //	缩小图片的按钮
    reset: true, //	重置图片大小的按钮
    prev: false, //	查看上一张图片的按钮
    next: false, //	查看上一张图片的按钮
    play: true, //	播放图片的按钮
    rotateLeft: true, //	向左旋转图片的按钮
    rotateRight: true, //	向右旋转图片的按钮
    flipHorizontal: false, //	图片左右翻转的按钮
    flipVertical: false, //	图片上下翻转的按钮
  },
});
Vue.config.productionTip = false;

Vue.use(CKEditor).use(ElementUI, { size: "mini" }).use(CustomComponents).use(WatermarkPlugin);

Vue.prototype.$utils = utils;
Vue.prototype.$const = customConst;
Vue.prototype.$mqtt = mqtt;
Vue.prototype.$IndexDB = IndexDB;
Vue.prototype.$AMap = AMap;
Vue.prototype.$bus = new Vue();

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
